module.exports = __webpack_public_path__ + "img/date-popup-banner.bb0acdd6.png";